import React from 'react';
import Channel from './Channel';
import Create from '../../assets/img/channel-icon/createChannel';

const Channels = ({ list, type, popUp, setId }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {type === 'created' && list.length < 3 && (
        <div
          id="createChannel"
          onClick={() => popUp?.()}
          className="aspect-square bg-gray-800/50 border-2 border-dashed border-gray-600 rounded-xl flex items-center justify-center cursor-pointer hover:border-primary hover:bg-gray-800 transition-all"
        >
          <div className="text-gray-400 hover:text-primary transition-colors">
            <Create />
          </div>
        </div>
      )}
      {list.map(v => (
        <Channel
          key={v.id}
          listData={v}
          type={type}
          setId={state => {
            setId?.(state);
          }}
        />
      ))}
    </div>
  );
};

export default Channels;
